import Vue from "vue"
import orderListColumnTitles from "../../data/orderListColumnTitles";
import countries from "../../data/countries";
import refundsSearchOptions from "../../data/refundsSearchOptions";
import FulfillmentMethods from "../../data/fulfillmentMethods"
import moment from "moment/moment";
import {dispatchRequestStatus} from "../../helpers/dispatch";

export const SEARCHABLE_DISPATCH_REQUEST_STATUSES = [
    'requires-hold-evaluation',
    'to-be-requested',
    'requested',
    'requested-paused',
    'shipped',
    'unable-to-ship',
    'unable-to-ship-final',
    'cancelled',
    'return-announced',
    'return-received',
    'shipped-with-issues',
    'waiting-for-stock',
    'unable-to-assign',
]

export const OrderSearchBase = Vue.extend({
    computed: {
        FILTER_COLUMN_DISPLAY_NAMES() {
            return orderListColumnTitles
        },
        dispatchers() {
            return this.$store.state.locationsForUser
                .filter(d => d.location_type.identifier === this.value.dispatcher_type)
                .sort((a,b) => {
                    if (a.display_name > b.display_name) return 1
                    if (a.display_name < b.display_name) return -1
                    return 0
                })
        },
        responsibleStoreOptions() {
            return this.$store.state.locationsForUser
                .filter(d => d.location_type.identifier === 'store')
                .sort((a,b) => {
                    if (a.display_name > b.display_name) return 1
                    if (a.display_name < b.display_name) return -1
                    return 0
                })
        },
        holdStatuses() {
            return [
                {identifier: 'Review', display_name: 'Geblokkeerd'},
                {identifier: 'Accepted', display_name: 'Geaccepteerd'},
                {identifier: 'Denied', display_name: 'Definitief geblokkeerd'},
            ]
        },
        dispatchRequestStatuses() {
            let searchStatuses = {}

            SEARCHABLE_DISPATCH_REQUEST_STATUSES.forEach(status => {
                searchStatuses[status] = dispatchRequestStatus(status)
            })

            return searchStatuses
        },
        countries() {
            return countries
        },
        refundsSearchOptions() {
            return refundsSearchOptions
        },
        isSearchingForOrderNumber() {
            return !!this.value.order_identifier
        },
        isSearchingForOrderPlacedFrom() {
            return !!this.value.order_placed_from
        },
        minOrderPlacedFrom() {
            if (!this.value.order_placed_to) {
                return null
            }

            let min = moment(this.value.order_placed_to)
            min.subtract(30, 'days')
            return min.format('YYYY-MM-DD')
        },
        fulfillmentMethods() {
            return FulfillmentMethods
        },
        addressTypes() {
            return [
                {identifier: 'billing', display_name: 'Factuuradres'},
                {identifier: 'shipping', display_name: 'Verzendadres'},
            ]
        }
    },

    methods: {
        isFieldEditable(field) {
            if (this.searchFilterSet?.filters[field] && field !== 'max_age_days') {
                return false
            }

            if (
                field !== 'order_identifier'
                && this.value.order_identifier?.length
                && !['responsible_location_type', 'responsible_location_identifier', 'dispatcher_type', 'dispatcher_identifier'].includes(field)
                && !this.hasPermission('canmanagealllocations')
            ) {
                return false
            }

            return true
        },
        filterDispatcherTypeChanged() {
            this.value.dispatcher_identifier = ''
        },
    }
})
